// Feature Flags
// Those can be managed in Launchy Dark
// https://app.launchdarkly.com/

// SP
export const PORTAL_FF_SP = 'portal-ff-sp'
export const PORTAL_FF_SP_BROAD_KEYWORD = 'portal-ff-sp-broad-keyword'

// DISPLAY ADS
export const PORTAL_FF_DA = 'portal-ff-da'
export const PORTAL_FF_DA_AUDIENCES_TARGETING_VIEW =
  'portal-ff-da-audiences-targeting-view'
export const PORTAL_FF_DA_AUDIENCES_TARGETING_EDIT =
  'portal-ff-da-audiences-targeting-edit'
export const PORTAL_FF_DA_AUDIENCES_ANALYTICS_VIEW =
  'portal-ff-da-audiences-analytics-view'
export const PORTAL_FF_DA_DAY_TIME_TARGETING_VIEW =
  'portal-ff-da-day-time-targeting-view'
export const PORTAL_FF_DA_DAY_TIME_TARGETING_EDIT =
  'portal-ff-da-day-time-targeting-edit'
export const PORTAL_FF_DA_PURCHASE_ATTRIBUTION =
  'portal-ff-da-purchase-attribution'
export const PORTAL_FF_DA_PRODUCT_FEED_PACKSHOT =
  'portal-ff-da-product-feed-packshot'

// DOOH
export const PORTAL_FF_DOOH = 'portal-ff-dooh'
export const PORTAL_FF_DOOH_CREATE = 'portal-ff-dooh-create'
export const PORTAL_FF_DOOH_UPDATE = 'portal-ff-dooh-update'
export const PORTAL_FF_DOOH_DAY_TIME_TARGETING_VIEW =
  'portal-ff-dooh-day-time-targeting-view'
export const PORTAL_FF_DOOH_DAY_TIME_TARGETING_EDIT =
  'portal-ff-dooh-day-time-targeting-edit'
export const PORTAL_FF_DOOH_AUDIENCES_TARGETING_CREATE =
  'portal-ff-dooh-audiences-targeting-create'
export const PORTAL_FF_DOOH_AUDIENCES_TARGETING_EDIT =
  'portal-ff-dooh-audiences-targeting-edit'

// Reporting
export const PORTAL_FF_REPORTING_METRICS_OMIT =
  'portal-ff-reporting-metrics-omit'
export const PORTAL_FF_REPORTING_V_3_AD_GROUPS =
  'portal-ff-reporting-v-3-ad-groups'
export const PORTAL_FF_REPORTING_V_3_ADVERTISERS =
  'portal-ff-reporting-v-3-advertisers'
export const PORTAL_FF_REPORTING_V_3_AUDIENCES =
  'portal-ff-reporting-v-3-audiences'
export const PORTAL_FF_REPORTING_V_3_CAMPAIGNS =
  'portal-ff-reporting-v-3-campaigns'
export const PORTAL_FF_REPORTING_V_3_CATEGORIES =
  'portal-ff-reporting-v-3-categories'
export const PORTAL_FF_REPORTING_V_3_CREATIVES =
  'portal-ff-reporting-v-3-creatives'
export const PORTAL_FF_REPORTING_V_3_FILTERS = 'portal-ff-reporting-v-3-filters'
export const PORTAL_FF_REPORTING_V_3_KEYWORDS =
  'portal-ff-reporting-v-3-keywords'
export const PORTAL_FF_REPORTING_V_3_PRODUCTS =
  'portal-ff-reporting-v-3-products'
export const PORTAL_FF_REPORTING_V_3_SEARCH_TERMS =
  'portal-ff-reporting-v-3-search-terms'
export const PORTAL_FF_REPORTING_V3_POSITIONS =
  'portal-ff-reporting-v-3-positions'

export const PORTAL_FF_REPORTING_EXPORT_EXCEL =
  'portal-ff-reporting-export-excel'

// Keyword suggestions
export const PORTAL_FF_SUGGESTED_KEYWORD_VIEW =
  'portal-ff-sp-suggested-keyword-view'

// Search Terms
export const PORTAL_FF_REPORTING_SEARCH_TERMS =
  'portal-ff-reporting-search-terms'

// Direct Deals
export const PORTAL_FF_DIRECT_DEAL_CREATE = 'portal-ff-direct-deal-create'

// Forecasting
export const PORTAL_FF_DA_FORECASTING = 'portal-ff-da-forecasting'
export const PORTAL_FF_DOOH_FORECASTING = 'portal-ff-dooh-forecasting'

// Product ID identifier
export const PORTAL_FF_PRODUCT_ID_COLUMN_IDENTIFIER =
  'portal-ff-product-id-column-identifier'

// MFA
export const PORTAL_FF_MFA_EXCEPTION_LIST = 'portal-ff-mfa-exception-list'

// History
export const PORTAL_FF_CAMPAIGN_HISTORY = 'portal-ff-campaign-history'
export const PORTAL_FF_AD_GROUP_HISTORY = 'portal-ff-ad-group-history'
